/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { getEventId } from '@e180/domain/lib/event/util';
import { getMembershipTimeFormat } from '@e180/domain/lib/membership/util';

import { getAuthenticationToken } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { getLocaleTimeFormat } from 'src/shared/app/locale/util/localeUtils';
import useEvent from 'src/shared/domain/event/hook/useEvent';
import { patchMembership } from 'src/shared/domain/membership/action/membershipActions';
import useMembership from 'src/shared/domain/membership/hook/useMembership';

export default function useTimeFormatPatch() {
  const token = useSelector(getAuthenticationToken);
  const { locale } = useIntl();
  const dispatch = useDispatch();
  const membership = useMembership();
  const event = useEvent();
  const membershipTimeFormat = membership
    ? getMembershipTimeFormat(membership)
    : '';

  React.useEffect(() => {
    if (token && !membershipTimeFormat) {
      dispatch(
        patchMembership(getEventId(event), {
          preferences: {
            time_format: getLocaleTimeFormat(locale),
          },
        }),
      );
    }
  }, [token, membershipTimeFormat]);
}
